var amdi18n={"__root":{"fetch_configuration_failed":"Fetch configuration failed","format_invalid":"Configuration format is invalid","version_invalid":"VERSION setting is invalid","IDM_URL_invalid":"IDM_URL setting is invalid","options_url_invalid":"OPTIONS_URL setting is invalid","select_option_url_invalid":"SELECT_OPTION_URL setting is invalid","cancel_select_option_url_invalid":"CANCEL_SELECT_OPTION_URL setting is invalid","attribute_definitions_url_invalid":"ATTRIBUTE_DEFINITIONS_URL setting is invalid","privacy_document_url_invalid":"PRIVACY_DOCUMENT_URL setting is invalid","cloud_identity_request_url_invalid":"CLOUD_IDENTITY_REQUEST_URL setting is invalid","cloud_identity_management_url_invalid":"CLOUD_IDENTITY_MANAGEMENT_URL setting is invalid","option_images_index_url_invalid":"OPTION_IMAGES_INDEX_URL setting is invalid","option_images_url_invalid":"OPTION_IMAGES_URL setting is invalid","open_ecard_supported_cards_protocols_url_invalid":"OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_URL setting is invalid","open_ecard_webstart_jnlp_url_invalid":"OPEN_ECARD_WEBSTART_JNLP_URL setting is invalid","open_ecard_app_status_url_invalid":"OPEN_ECARD_APP_STATUS_URL setting is invalid","java_download_url_invalid":"JAVA_DOWNLOAD_URL setting is invalid"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/util/nls/Configuration_strings.js
// module id = 166
// module chunks = 6